import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../components/other/Loader";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import NoRecord from "../components/other/NoRecord";
import { pageRoutes } from "../routes/pageRoutes";
import {
  blockUnblockedGroupAdmin,
  deleteGroupReport,
  fetchGroupReport,
  warnToReportedGroup,
} from "../redux/action/groupReportAction";
import { pipTimeView, pipViewDate2 } from "../utils/pip";
import ReactPagination from "../components/reactPagination";
import PaginationDropdown from "../components/PaginationDropdown";
import { message } from "antd";

const GroupReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isToggle } = useSelector((state) => state?.authReducer);
  const { allGroupReportList, isLoading } = useSelector(
    (state) => state?.groupReportReducer
  );
  const [selectedGroup, setSelectedGroup] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);
  const [selectedGropReport, setSelectedGropReport] = useState({});

  const [filterCriteria, setFilterCriteria] = useState({
    searchQuery: "",
  });
  const [filteredGroupReportList, setFilteredGroupReportList] = useState([]);

  useEffect(() => {
    dispatch(fetchGroupReport());
  }, [dispatch]);


  useEffect(() => {
    if (filterCriteria.searchQuery === "") {
      setFilteredGroupReportList(allGroupReportList);
    } else {
      const filteredList = allGroupReportList.filter(
        (item) =>
          item.group_data &&
          item.group_data.groupName
            .toLowerCase()
            .includes(filterCriteria.searchQuery.toLowerCase())
      );
      setFilteredGroupReportList(filteredList);
    }
  }, [allGroupReportList, filterCriteria]);

  const handleDeleteUser = () => {
    const data = {
      group_id: selectedGroup?.group_id,
      group_type: selectedGroup?.group_data?.groupType,
    };
    const callback = (response) => {
      if (response?.success) {
        dispatch(fetchGroupReport());
      }
    };
    dispatch(deleteGroupReport({ payload: data, callback }));
  };

  const paginatedGroupReport = filteredGroupReportList?.slice(
    currentPage * usersPerPage,
    (currentPage + 1) * usersPerPage
  );

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterCriteria((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSendWarning = (value) => {
    console.log(value?.group_data?.adminId);
    const data = {
      user_id: `${value?.group_data?.adminId}`
    }
    const callback = (response) => {
      if (response.success) {
        dispatch(fetchGroupReport());
      };
    };
    dispatch(warnToReportedGroup({ payload: data, callback }));
  };

  const handleSendDelete = (value) => {
    if (value?.admin_data?.is_blocked == 0) {
      console.log(value?.group_data?.adminId);
      const data = {
        user_id: `${value?.group_data?.adminId}`,
        block_status: true,
      }
      const callback = (response) => {
        if (response.success) {
          dispatch(fetchGroupReport());
        };
      };
      dispatch(blockUnblockedGroupAdmin({ payload: data, callback }));
    } else {
      message.success("Admin is already blocked", 2);
    }
  };

  if (isLoading) {
    return <Loader />;
  }


  return (
    <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
      <Sidebar />
      <div class="ct_right_content">
        <Header />
        <div class="ct_inner_dashbaord_main">
          <div class="ct_right_header">
            <div class="ct_left_header_cnt">
              {/* <SearchInput onSearch={handleSearch} /> */}
              <div className="form-group">
                <label htmlFor="" className="mb-2 ct_fw_600 ct_nbsp_none_1199">
                  &nbsp;
                </label>
                <div className="position-relative">
                  <i className="fa-solid fa-magnifying-glass ct_search_icon_12"></i>
                  <input
                    type="text"
                    className="form-control ct_input ct_text_indent_30"
                    placeholder="Search"
                    name="searchQuery"
                    value={filterCriteria.searchQuery}
                    onChange={handleFilterChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <ul class="d-flex align-items-center  gap-2 mb-0">
              <li>
                {" "}
                <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                  All Reported Groups
                </h4>
              </li>
              <li>
                {" "}
                <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                  <i class="bi bi-dot"></i>
                </h4>
              </li>
              <li>
                {" "}
                <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                  {allGroupReportList?.length}{" "}
                  {allGroupReportList?.length <= 1 ? "Group" : "Groups"}{" "}
                </h4>
              </li>
            </ul>
          </div>
          <div class="ct_mt_28">
            <div class="row ">
              <div class="col-xxl-12 col-xl-12 mb-4 mb-xl-0 ">
                <div class="ct_top_sticky">
                  <div class="">
                    <div class="table-responsive">
                      <table class="table ct_custom_table ct_verticle_midddle_table123">
                        <thead>
                          <tr>
                            <th>S.No.</th>
                            <th>Group Image</th>
                            <th>Name & Location</th>
                            <th>Description</th>
                            <th>Type</th>
                            <th>Created At</th>
                            <th>Warning / Block</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedGroupReport &&
                            paginatedGroupReport.length !== 0 ? (
                            paginatedGroupReport.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <div className="d-flex align-items-center gap-2">
                                      <img
                                        src={
                                          item?.group_data?.groupImage
                                            ? item?.group_data?.groupImage
                                            : "/user_profile.png"
                                        }
                                        alt="Group Image"
                                        className="ct_img_60"
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center gap-2 ">
                                      <div>
                                        <h5 class="ct_fs_14 ct_fw_700 mb-0">
                                          {item?.group_data?.groupName ?? ''}
                                        </h5>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p
                                        className="mb-0 ct_white_space_3_dot_12"
                                      >
                                        {" "}
                                        {item?.group_data?.description ?? ''}
                                      </p>
                                    </div>
                                  </td>

                                  <td>
                                    <div>
                                      <p class="mb-0 ct_fw_600 ct_fs_16 ct_fw_600" style={{ textTransform: 'capitalize' }}>
                                        {item?.group_data?.groupType ?? ''}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p class="mb-0 ct_fw_600 ct_fs_16 ct_fw_600">
                                        {pipViewDate2(item?.created_at)}{" "}
                                        <span>
                                          {" "}
                                          {pipTimeView(item?.created_at)}
                                        </span>
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="d-flex align-items-center gap-2">
                                      {item?.admin_data?.is_blocked != 1 && <button className="ct_orange_btn   d-flex  align-items-center justify-content-center  mx-auto" style={{ borderRadius: "5px", height: "40px" }} onClick={() => handleSendWarning(item)}>Warning</button>
                                      }
                                      <button className="ct_orange_btn ct_red_btn_123  d-flex  align-items-center justify-content-center  mx-auto" style={{ borderRadius: "5px", height: "40px" }} onClick={() => handleSendDelete(item)}>{item?.admin_data?.is_blocked == 1 ? 'Blocked' : 'Block'}</button>

                                    </div>
                                  </td>
                                  <td class="text-center">
                                    <div class="">
                                      <div className="">
                                        <p className="mb-0  ms-auto d-flex align-items-center gap-3 justify-content-end">
                                          <i
                                            class="fa-solid fa-eye ct_pointer_curser"
                                            data-bs-toggle="modal"
                                            data-bs-target="#ct_group_report_detail_modal"
                                            onClick={() =>
                                              setSelectedGropReport(item)
                                            }
                                          ></i>
                                          <i
                                            class="fa-solid fa-trash-can ct_pointer_curser ct_red_text"
                                            onClick={() =>
                                              setSelectedGroup(item)
                                            }
                                            data-bs-toggle="modal"
                                            data-bs-target="#ct_delete_account_modal"
                                          ></i>
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={7}>
                                {filterCriteria.searchQuery ? (
                                  <h3 className="text-center">
                                    There are no results with this search.
                                  </h3>
                                ) : (
                                  <NoRecord />
                                )}
                                {/* {allGroupReportList.length === 0 ? (
                                    <NoRecord />
                                  ) : (
                                    <h3 className="text-center">
                                     There are no results with this search.
                                    </h3>
                                  )} */}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {paginatedGroupReport && paginatedGroupReport?.length != 0 && (
            <>
              <div className="d-flex justify-content-between align-items-center mt-4">
                <div>
                  <PaginationDropdown
                    onChange={(val) => {
                      setUserPerPages(val);
                      setCurrentPage(0);
                    }}
                  />
                </div>
                <div>
                  <ReactPagination
                    pageCount={Math.ceil(
                      allGroupReportList?.length / usersPerPage
                    )}
                    onPageChange={handlePageClick}
                  />
                </div>
              </div>

              <div
                class="modal fade"
                id="ct_description_view_modal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        Description
                      </h5>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <p className="mb-0">
                        {/* {item?.group_data?.description} */}
                        {/* {modalDescription} */}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {/* delete modal start  */}
        <div
          class="modal fade ct_assets_modal"
          id="ct_delete_account_modal"
          tabindex="-1"
          aria-labelledby="ct_delete_modalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header border-0 pt-0">
                <button
                  type="button"
                  class="btn-close ct_cloose_btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
              <div class="modal-body border-0 ">
                <i className="fa-solid fa-trash-can ct_red_text ct_fs_30 text-center d-block mb-4"></i>
                <h4 class="text-center mb-2 ct_fw_600">Confirm Delete</h4>
                <p className="text-center mb-0">
                  Are you sure? you want to delete it.
                </p>

                <div class="modal-footer border-0 justify-content-center">
                  <button
                    type="button"
                    class="ct_orange_btn ct_cancel_btn"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <a
                    type="button"
                    class=" bg-danger  ct_orange_btn  justify-content-center"
                    style={{ borderColor: "rgb(220, 53, 69)" }}
                    data-bs-dismiss="modal"
                    onClick={() => handleDeleteUser()}
                  >
                    Delete
                  </a>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>

        {/* details modal */}
        <div
          class="modal fade modal-lg"
          id="ct_group_report_detail_modal"
          tabindex="-1"
          aria-labelledby="ct_group_report_detail_modalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header border-0 pb-0">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div className="ct_gropp_detail_modal_main">
                  <div class="row align-items-center">
                    <div class="col-xl-4 col-md-5 mb-4 mb-md-0">
                      <figure>
                        <div class="ct_user_img_1">
                          <img
                            src={
                              selectedGropReport?.group_data?.groupImage ||
                              "./user_profile.png"
                            }
                            alt=""
                          />
                        </div>
                      </figure>
                    </div>
                    <div class="col-xl-8 col-md-7 mb-4 mb-md-0">
                      <div>
                        <div>
                          <div class=" ct_mb_20">
                            <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">
                              Group Name
                            </h4>
                            <ul>
                              <li>
                                {selectedGropReport?.group_data?.groupName}
                              </li>
                            </ul>
                          </div>
                          <div class=" ct_mb_20">
                            <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">Type</h4>
                            <ul>
                              <li>
                                {selectedGropReport?.group_data?.groupType}
                              </li>
                            </ul>
                          </div>
                          <div class=" ct_mb_20">
                            <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">
                              Created At
                            </h4>
                            <ul>
                              {pipViewDate2(selectedGropReport?.created_at)}{" "}
                              <span>
                                {" "}
                                {pipTimeView(selectedGropReport?.created_at)}
                              </span>
                            </ul>
                          </div>
                          <div class=" ct_mb_20">
                            <h4 class="ct_fs_16 ct_fw_600 ct_mb_15 ">
                              Description
                            </h4>
                            <p style={{ wordBreak: "break-all" }}>
                              {selectedGropReport?.group_data?.description}
                            </p>
                          </div>

                          <div class=" ct_mb_20">
                            <h4 class="ct_fs_16 ct_fw_600 ct_mb_15 ">
                              Reported By
                            </h4>
                            <p style={{ wordBreak: "break-all" }}>
                              {selectedGropReport?.sender?.name}
                            </p>
                          </div>
                          <div class=" ct_mb_20">
                            <h4 class="ct_fs_16 ct_fw_600 ct_mb_15 ">
                              Group Created By
                            </h4>
                            <p style={{ wordBreak: "break-all" }}>
                              Name : {selectedGropReport?.admin_data?.name}
                            </p>
                            <p style={{ wordBreak: "break-all" }}>
                              UserName : {selectedGropReport?.admin_data?.username}
                            </p>
                          </div>
                          <div class=" ct_mb_20">
                            <h4 class="ct_fs_16 ct_fw_600 ct_mb_15 ">
                              No. Of Member
                            </h4>
                            <p style={{ wordBreak: "break-all" }}>
                              {selectedGropReport?.group_data?.member.length}
                            </p>
                          </div>

                          <div class=" ct_mb_20">
                            <h4 class="ct_fs_16 ct_fw_600 ct_mb_15 ">
                              Report Reason
                            </h4>
                            <p style={{ wordBreak: "break-all" }}>
                              {selectedGropReport?.comment}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default GroupReport;
